<div class="select-dealer">
    <div class="select-dealer__container">
        <label class="select-dealer__label">Select Dealer Business Name</label>
        <div class="flex items-center justify-between">
            <p class="select-dealer__description">Add Dealer Advertiser's associate dealers</p>
            @if (!hideErrorMessage()) {
                <span class="select-dealer__error-text">{{ errorMessage() }}</span>
            }
        </div>
        <app-autocomplete
            [loading]="isLoadingDealers()"
            [options]="dealerList()"
            [(selectedOptions)]="selectedDealers"
            [error]="hideErrorMessage() ? '' : errorMessage()"
            [config]="{
                placeholder: 'Select Dealer',
                multiple: true,
                searchable: true,
            }"
            (onSearch)="onDealerSearch($event)" />
    </div>

    <div class="select-dealer__container">
        <label class="select-dealer__label">No Selected Dealer Name (s)</label>
        <p class="select-dealer__description">
            This field displays the dealer name or names that have been selected
        </p>
        <div class="selected-dealers__container">
            @for (dealer of selectedDealers(); track dealer) {
                <div class="selected-dealers__item">
                    <div class="flex items-center gap-5">
                        <div class="relative top-0.5">
                            <ntv-checkbox [checked]="true" size="sm" />
                        </div>
                        <span class="selected-dealers__item-label">{{ dealer.label }}</span>
                    </div>

                    <button class="selected-dealers__item-remove" (click)="removeDealer(dealer)">
                        <svg width="12" height="12" color="red">
                            <use href="assets/icons/icons-sprite.svg#outline-trash" />
                        </svg>
                    </button>
                </div>
            } @empty {
                <p class="text-sm text-gray-400 font-semibold">Please select dealer/s</p>
            }
        </div>
    </div>
</div>
